import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeGoogleSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const userData = await exchangeGoogleSession(sessionId);
        // strip the hash and go to account
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true, state: { user: userData } });
      } catch {
        navigate("/login", { replace: true, state: { error: "Google sign-in failed." } });
      }
    };
    run();
  }, [exchangeGoogleSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0F0F10]">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#4ADE80] mx-auto" />
        <p className="mt-6 font-mono-accent text-sm uppercase tracking-widest text-[#7a7a7a]">
          Signing you in…
        </p>
      </div>
    </div>
  );
}
